import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useWorkspace } from '../context/WorkspaceContext';
import { Loader2 } from 'lucide-react';

export default function ProtectedRoute({ children, requireAdmin = false, requireWorkspaceAdmin = false }) {
  const { isAuthenticated, isAdmin, loading } = useAuth();
  const { isWorkspaceAdmin, loading: wsLoading } = useWorkspace();
  const location = useLocation();

  if (loading || wsLoading) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="w-8 h-8 text-emerald-500 animate-spin" />
          <p className="text-zinc-400">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/menus" replace />;
  }

  // requireWorkspaceAdmin allows access if user is superadmin OR workspace admin
  if (requireWorkspaceAdmin && !isAdmin && !isWorkspaceAdmin) {
    return <Navigate to="/menus" replace />;
  }

  return children;
}
